const BASE_SIZE = 16;

export const pxToRem = (px: number, base: number = BASE_SIZE): string => {
  if (px === 0) return '0';
  return `${px / base}rem`;
};

export const remToPx = (rem: number, base: number = BASE_SIZE): string => {
  if (rem === 0) return '0';
  return `${rem * base}px`;
};
